import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tabs,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useNavigate, useParams } from 'react-router-dom';
import Heading from '../../common/Heading/Heading';
import AccountsList from './AccountsList';
import {
  addSalaryComponentHr,
  getSalaryComponentHrDetails,
  updateSalaryComponentHr,
} from '../../../network/salaryComponentHr';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBillWheat } from 'react-icons/fa6';

const AddSalaryComponentHr = ({ t, edit }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const [dataSourceUom, setDataSourceUom] = useState([
    {
      company: companyName,
    },
  ]);
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const watchAmountBasedOnFormula = Form.useWatch(
    'amount_based_on_formula',
    form
  );
  // console.log(isFixedAsset,"isFixedAsset");

  const { mutate: onAddSalaryComponentHr } = useMutation({
    mutationKey: ['addSalaryComponentHr'],
    mutationFn: (body) =>
      edit ? updateSalaryComponentHr(body, id) : addSalaryComponentHr(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getSalaryComponentHr] });
      form.resetFields();
      navigate('/salary-component-hr');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const {
    data: salaryComponentHrDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getSalaryComponentHr, id],
    queryFn: () => getSalaryComponentHrDetails(id),
    enabled: !!edit,
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (edit && salaryComponentHrDetails) {
      setDataSourceUom(
        salaryComponentHrDetails?.data.accounts?.length
          ? salaryComponentHrDetails?.data.accounts
          : [
              {
                company: companyName,
              },
            ]
      );
      form.setFieldsValue({
        ...salaryComponentHrDetails?.data,
      });
    } else {
      form.resetFields();
    }
  }, [edit, salaryComponentHrDetails, form]);

  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddSalaryComponentHr({
      ...values,
      disabled: values?.disabled ? 1 : 0,
      depends_on_payment_days: values?.depends_on_payment_days ? 1 : 0,
      round_to_the_nearest_integer: values?.round_to_the_nearest_integer
        ? 1
        : 0,
      do_not_include_in_total: values?.do_not_include_in_total ? 1 : 0,
      remove_if_zero_valued: values?.remove_if_zero_valued ? 1 : 0,
      amount_based_on_formula: values?.amount_based_on_formula ? 1 : 0,
      accounts: dataSourceUom?.map((item) => ({
        ...item,
      })),
    });
  };
  if (isLoading) {
    return (
      <Card>
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      </Card>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.editSalaryComponent : t.addSalaryComponent}
        path="/salary-component-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.salaryComponent}
        subTitle={edit ? t.editSalaryComponent : t.addSalaryComponent}
        icon={<FaMoneyBillWheat />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-Item-Price"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col sm={12} md={12} lg={8} xl={8}>
                  <Form.Item
                    name="salary_component"
                    label={t.salaryComponent}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.salaryComponent} />
                  </Form.Item>
                </Col>
                <Col sm={12} md={12} lg={8} xl={8}>
                  <Form.Item
                    name="salary_component_abbr"
                    label={t.SalaryComponentAbbreviation}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.SalaryComponentAbbreviation} />
                  </Form.Item>
                </Col>
                <Col sm={12} md={12} lg={8} xl={8}>
                  <Form.Item
                    name="type"
                    label={t.type}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.type}
                      options={[
                        {
                          value: 'Earning',
                          label: t.Earning,
                        },
                        {
                          value: 'Deduction',
                          label: t.Deduction,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {/* <Col sm={12} md={12} lg={8} xl={8}>
            <Form.Item name="purchase_uom" label={t.purchaseUOM}>
              <Select
                showSearch
                placeholder={t.purchaseUOM}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={stockUoms?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                }))}
              />
            </Form.Item>
          </Col> */}

                <Col sm={12} md={12}>
                  <Form.Item
                    name="condition"
                    label={t.condition}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input.TextArea
                      autoSize={{ minRows: 3, maxRows: 5 }}
                      placeholder={t.condition}
                    />
                  </Form.Item>
                </Col>
                {!watchAmountBasedOnFormula && (
                  <Col sm={12} md={12} lg={8} xl={8}>
                    <Form.Item
                      name="amount"
                      label={t.amount}
                      // rules={[
                      //   {
                      //     required: true,
                      //   },
                      // ]}
                    >
                      <Input placeholder={t.amount} type="number" min={0} />
                    </Form.Item>
                  </Col>
                )}
                {watchAmountBasedOnFormula && (
                  <Col sm={12} md={12} lg={8} xl={8}>
                    <Form.Item
                      name="formula"
                      label={t.formula}
                      // rules={[
                      //   {
                      //     required: true,
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder={t.formula}
                        // type="number"
                        // min={0}
                        // onChange={
                        //   (e) => {
                        //     form.setFieldsValue({formula: e.target.value})
                        //   }
                        // }
                      />
                    </Form.Item>
                  </Col>
                )}

                <Col span={24}>
                  <AccountsList
                    form={form}
                    t={t}
                    dataSourceUom={dataSourceUom}
                    setDataSourceUom={setDataSourceUom}
                  />
                </Col>
                <Divider />
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="depends_on_payment_days"
                    label={t.dependsOnPaymentDays}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="round_to_the_nearest_integer"
                    label={t.roundToTheNearestInteger}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="do_not_include_in_total"
                    label={t.doNotIncludeInTotal}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="remove_if_zero_valued"
                    label={t.removeIfZeroValued}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="disabled"
                    label={t.disabled}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="amount_based_on_formula"
                    label={t.amountBasedOnFormula}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddSalaryComponentHr;
